<template>
  <div class="animated fadeIn">
    <div v-if="loading" class="loading-container">
      <RotateSquare
        class="loading-position animated fadeIn"
        size="60px"
      ></RotateSquare>
    </div>
    <form v-else @submit="ValidarForm">
      <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <div class="card">
            <header class="card-header">
              <strong class="align-self-center">{{
                $t("sectionUsuario.usuarioNovoTitle")
              }}</strong>
            </header>
            <div class="card-body">
              <div class="row">
                <div class="col">
                  <div class="form-group">
                    <small>{{ $t("textObrigatorios") }}</small>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                  <div class="form-group">
                    <label for
                      >* {{ $t("sectionUsuario.usuarioNomeCliente") }}</label
                    >
                    <input
                      v-model="viewModel.apelido"
                      maxlength="32"
                      class="form-control"
                      type="text"
                      placeholder="Digite o nome/apelido"
                      required
                    />
                  </div>
                </div>
                <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                  <div class="form-group">
                    <label for>* {{ $t("sectionUsuario.usuarioEmail") }}</label>
                    <input
                      v-model="viewModel.email"
                      class="form-control"
                      type="email"
                      placeholder="Digite o e-mail"
                      required
                    />
                  </div>
                </div>
                <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                  <div class="form-group">
                    <label for>* {{ $t("sectionUsuario.usuarioSenha") }}</label>
                    <input
                      v-model="viewModel.senha"
                      class="form-control"
                      type="password"
                      :placeholder="$t('sectionTrocarSenha.digiteSenha')"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div
                  class="col-sm-12 col-md-4 col-lg-4 col-xl-4"
                  title="Perfil de acesso do usuário ao sistema."
                >
                  <div class="form-group">
                    <label for
                      >* {{ $t("sectionUsuario.usuarioPerfil") }}</label
                    >
                    <select
                      v-model="viewModel.perfil"
                      class="form-control"
                      required
                    >
                      <option disabled selected value>
                        {{ $t("textSelecione") }}
                      </option>
                      <option value="2">{{ $t("textAdministrador") }}</option>
                      <option value="3">{{ $t("textComum") }}</option>
                    </select>
                  </div>
                </div>
                <div
                  class="col-sm-6 col-md-3 col-lg-3 col-xl-2"
                  :title="$t('sectionAtendimento.handlesConversations')"
                >
                  <label for>{{
                    $t("sectionUsuario.usuarioAtendimento")
                  }}</label>
                  <b-form-checkbox
                    v-model="viewModel.atendente"
                    name="check-button"
                    switch
                  >
                    {{ $t("textYes") }}
                  </b-form-checkbox>
                </div>
                <div
                  class="col-sm-6 col-md-2 col-lg-2 col-xl-1"
                  :title="$t('sectionAtendimento.activeToUseTheSystem')"
                >
                  <label for>{{ $t("sectionPessoa.pessoaStatusAtivo") }}</label>
                  <b-form-checkbox
                    v-model="viewModel.ativo"
                    name="check-button"
                    switch
                  >
                    {{ $t("textYes") }}
                  </b-form-checkbox>
                </div>
                <div
                  class="col-sm-9 col-md-2 col-lg-2 col-xl-3"
                  :title="$t('sectionUsuario.usuarioBloqueioTransferenciaAtendimento')"
                >
                  <label for>{{ $t("sectionUsuario.usuarioBloqueioTransferencia") }}</label>
                  <b-form-checkbox
                    v-model="viewModel.bloquearTransferencia"
                    name="check-button"
                    switch
                  >
                    {{ $t("textYes") }}
                  </b-form-checkbox>
                </div>
              </div>
              <div class="row">
                <div
                  class="col-sm-12 col-md-7 col-lg-7 col-xl-5"
                  :title="$t('sectionAtendimento.companyReleasedTo')"
                >
                  <div class="form-group">
                    <label for
                      >* {{ $t("sectionUsuario.usuarioEmpresa") }}</label
                    >
                  </div>
                  <v-select
                    v-model="viewModel.contas"
                    :placeholder="$t('textSelecione')"
                    :options="contaOptions"
                    multiple
                    required
                  >
                    <template slot="no-options">
                      {{ $t("sectionAtendimento.atendimentoNenhumResultado") }}
                    </template>
                  </v-select>
                </div>
              </div>
            </div>
          </div>
          <button class="btn btn-success mr-2" type="submit">
            {{ $t("btSalvar") }}
          </button>
          <button
            class="btn btn-secondary"
            type="reset"
            @click="$router.push('/usuario')"
          >
            {{ $t("btVoltar") }}
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import RotateSquare from "../../components/RotateSquare";

export default {
  name: "NovoUsuario",
  components: {
    RotateSquare
  },
  data() {
    return {
      loading: false,
      contaOptions: [],
      viewModel: {
        id: this.$store.state.emptyGuid,
        atendente: false,
        ativo: true,
        bloquearTransferencia:false,
        email: "",
        apelido: "",
        senha: "",
        perfil: "",
        contaId: this.$store.getters.getAutenticacao.contaSelecionadaId,
        contas: []
      }
    };
  },
  mounted() {
    let vm = this;
    if (
      this.$store.getters.getAutenticacao.contas &&
      this.$store.getters.getAutenticacao.contas.length > 0
    ) {
      for (
        let i = 0;
        i < this.$store.getters.getAutenticacao.contas.length;
        i++
      ) {
        this.contaOptions.push({
          id: vm.$store.getters.getAutenticacao.contas[i].id,
          label: vm.$store.getters.getAutenticacao.contas[i].nomeFantasia
        });
      }
    }
  },
  created() {
    let usuarioId = this.$route.params.id;
    if (usuarioId) this.Obter(usuarioId);
  },
  methods: {
    ValidarForm(evt) {
      evt.preventDefault();
      if (this.viewModel.id !== this.$store.state.emptyGuid) this.Editar();
      else this.Novo();
    },
    Obter(usuarioId) {
      this.loading = true;
      this.$http({
        url:
          "usuario/obter/" +
          usuarioId +
          "/" +
          this.$store.getters.getAutenticacao.contaSelecionadaId,
        method: "GET"
      })
        .then((resposta) => {
          this.loading = false;
          this.viewModel = resposta.data;
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 10000
          });
        });
    },
    Novo() {
      this.loading = true;
      this.$http({
        url: "usuario/novo",
        data: this.viewModel,
        method: "POST"
      })
        .then(() => {
          this.loading = false;
          this.$router.push("/usuario");
          this.$notify({
            data: ["Usuário cadastrado com sucesso."],
            type: "success",
            duration: 10000
          });
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 10000
          });
        });
    },
    Editar() {
      this.loading = true;
      this.$http({
        url: "usuario/editar",
        data: this.viewModel,
        method: "PUT"
      })
        .then(() => {
          this.loading = false;
          this.$router.push("/usuario");
          this.$notify({
            data: ["Usuário editado com sucesso."],
            type: "success",
            duration: 10000
          });
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 10000
          });
        });
    }
  }
};
</script>
